// extracted by mini-css-extract-plugin
export default {"table":"ConnectionList_table__ThSI7"};